module.exports = __webpack_public_path__ + "static/media/UltraTemp.3c04064a.jpg";